import { ReactElement } from 'react';

import { AppointmentConfiguration, AppointmentConfigurationQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../translations';

type SpecialistTimetableLoaderRenderer = (renderProps: {
   currentPractitioner: PractitionerDetails;

   appointmentConfiguration: AppointmentConfiguration;
}) => ReactElement;

type SpecialistTimetableLoaderProps = {
   readonly children: SpecialistTimetableLoaderRenderer;
};

export const SpecialistTimetableLoader = (props: SpecialistTimetableLoaderProps): JSX.Element => {
   const {
      data: appointmentConfiguration,
      loading: appointmentConfigurationLoading,
      error: appointmentConfigurationError,
   } = useCqrsGet<AppointmentConfiguration>(() => new AppointmentConfigurationQuery());

   const {
      data: currentPractitioner,
      loading: currentPractitionerLoading,
      error: currentPractitionerError,
   } = useCqrsGet<PractitionerDetails>(() => new CurrentPractitionerQuery());

   if (currentPractitionerLoading || appointmentConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (currentPractitionerError || appointmentConfigurationError) {
      return (
         <Message
            testId={'failedToFetchSpecialists'}
            label={calendarTranslationKeys.failedToFetchSpecialists}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      currentPractitioner: currentPractitioner,
      appointmentConfiguration: appointmentConfiguration,
   });
};
